import React, { useRef } from 'react'
import { Chart as ChartJS, CategoryScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
import { parseToChartData } from '../helpers';

ChartJS.register(CategoryScale, BarElement, Title, Tooltip, Legend);

const HorizontalBar = ({ data, donutMarginTop }) => {
    const barRef = useRef(null);
    const { symbols, holdingPercentages, colors, transparentColors } = parseToChartData(data);
    const xAxisHeight = 25;
    const barChartViewPortHeight = 250 - xAxisHeight + donutMarginTop;
    const barChartHeight = holdingPercentages.length * 30;

    const barData = {
        labels: symbols,
        datasets: [{
            label: 'Holding Percentages',
            data: holdingPercentages,
            backgroundColor: colors,
        }]
    }

    const axisData = {
        labels: symbols,
        datasets: [{
            data: holdingPercentages,
            backgroundColor: transparentColors
        }]
    }

    const barOptions = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        barThickness: 20,
        animation: false,
        scales: {
            x: {
                grid: {
                    display: false,
                    drawTicks: false,
                    drawBorder: false,
                },
                ticks: {
                    color: 'rgba(0, 0, 0, 0)'
                }
            },
            y: {
                grid: {
                    drawTicks: false,
                    drawBorder: false,
                },
                ticks: {
                    // display: false
                }
            }
        },
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: false,
            },
            datalabels: {
                color: (context) => {
                    const value = context.dataset.data[context.dataIndex];
                    const maxValue = Math.max(...context.dataset.data);
                    const percent = 0.1;

                    return value < percent * maxValue ? "black" : "white"; // Change color dynamically
                },
                anchor: (context) => {
                    const value = context.dataset.data[context.dataIndex];
                    const maxValue = Math.max(...context.dataset.data);
                    const percent = 0.1;

                    return value < percent * maxValue ? "end" : "center"; // Move text outside if < 5%
                },
                align: (context) => {
                    const value = context.dataset.data[context.dataIndex];
                    const maxValue = Math.max(...context.dataset.data);
                    const percent = 0.1;

                    return value < percent * maxValue ? "end" : "center"; // Align text outside when needed
                },
                formatter: (value) => `${value}%`, // Show actual value
                font: {
                    weight: 'bold',
                    size: 14
                }
            },
            // datalabels: {
            //     color: '#000',
            //     anchor: 'start',
            //     align: -45,
            //     formatter: (value) => `${value}%`, // Show actual value
            //     font: {
            //         weight: 'bold',
            //         size: 14
            //     }
            // },
        }
    }

    const axisOptions = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        barThickness: 20,
        animation: false,
        scales: {
            x: {
                grid: {
                    display: false,
                    drawTicks: false,
                    drawBorder: false,
                    color: 'rgba(0, 0, 0, 0)'
                },
            },
            y: {
                grid: {
                    display: false,
                    drawTicks: false,
                    drawBorder: false,
                    color: 'rgba(0, 0, 0, 0)'
                },
                ticks: {
                    color: 'rgba(0, 0, 0, 0)'
                    // display: false
                }
            },
        },
        plugins: {
            legend: {
                display: false
            }
        }
    }

    return (
        <div style={{ width: '100%'}}>

            {/* Scrollable Bar Chart */}
            <div style={{ position: 'relative', width: '100%', height: `${barChartViewPortHeight}px`, overflow: 'auto' }}>
                <div style={{ minHeight: `${barChartViewPortHeight}px`, height: `${barChartHeight}px` }}>
                    <Bar ref={barRef} data={barData} options={barOptions} plugins={[ChartDataLabels]} />
                </div>
            </div>

          {/* Fixed x-axis */}
            <div style={{ position: 'relative', width: '100%', height: `${xAxisHeight}px`, pointerEvents: 'none' }}>
                <div style={{ position: 'absolute', bottom: '0', left: '0', right: '0', minHeight: `${barChartViewPortHeight}px`, height: `${barChartHeight}px` }}>
                    <Bar data={axisData} options={axisOptions} />
                </div>
            </div>
        </div>
    )
}

export default HorizontalBar